import { render, staticRenderFns } from "./LogTemplatesForm.vue?vue&type=template&id=06146fd0"
import script from "./LogTemplatesForm.vue?vue&type=script&lang=js"
export * from "./LogTemplatesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports